/* =====================================================================
   UCHI — Shop all behaviour
   - Tab bar: counts per group, filters the groups, sticks under the header
   - Add to cart comes from uchi-v3.js ([data-u3-add])
   ===================================================================== */

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

/* ---------- Where the theme header ends ------------------------------ */
const headerGroup = document.getElementById('header-group') || document.querySelector('.header-section, header');
function headerBottom() {
  if (!headerGroup) return 0;
  return Math.max(0, Math.round(headerGroup.getBoundingClientRect().bottom));
}

function initTabs(head) {
  const nav = head.querySelector('[data-sa-tabs]');
  const slot = head.querySelector('[data-sa-slot]');
  if (!nav || !slot) return;
  const tabs = [...nav.querySelectorAll('[data-sa-tab]')];
  const groups = () => [...document.querySelectorAll('[data-sa-group]')];

  /* Counts */
  const counts = () => {
    let total = 0;
    groups().forEach((g) => {
      const n = g.querySelectorAll('[data-sa-card]').length;
      total += n;
      const el = nav.querySelector(`[data-sa-count="${CSS.escape(g.dataset.saGroup)}"]`);
      if (el) el.textContent = String(n);
    });
    const all = nav.querySelector('[data-sa-count="all"]');
    if (all) all.textContent = String(total);
  };
  counts();

  /* Filter */
  const select = (id, scroll) => {
    tabs.forEach((t) => t.setAttribute('aria-pressed', String(t.dataset.saTab === id)));
    groups().forEach((g) => { g.hidden = id !== 'all' && g.dataset.saGroup !== id; });
    const active = tabs.find((t) => t.dataset.saTab === id);
    if (active) {
      const row = active.parentElement;
      if (row.scrollWidth > row.clientWidth) row.scrollTo({ left: active.offsetLeft - 20, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }
    if (scroll && nav.classList.contains('is-fixed')) {
      const top = slot.getBoundingClientRect().top + window.scrollY - headerBottom();
      window.scrollTo({ top, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }
    if (history.replaceState) history.replaceState(history.state, '', id === 'all' ? location.pathname + location.search : `#${id}`);
  };
  tabs.forEach((t) => t.addEventListener('click', () => select(t.dataset.saTab, true)));
  const fromHash = location.hash.slice(1);
  if (fromHash && tabs.some((t) => t.dataset.saTab === fromHash)) select(fromHash, false);

  /* Stick under the header */
  let raf = 0;
  const place = () => {
    raf = 0;
    const top = headerBottom();
    document.documentElement.style.setProperty('--u3-top', `${top}px`);
    const fixed = slot.getBoundingClientRect().top < top;
    if (fixed !== nav.classList.contains('is-fixed')) {
      slot.style.height = fixed ? `${nav.offsetHeight}px` : '';
      nav.classList.toggle('is-fixed', fixed);
    }
  };
  const queue = () => { if (!raf) raf = requestAnimationFrame(place); };
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  place();
}

function init(scope = document) {
  scope.querySelectorAll('[data-sa-head]').forEach((head) => {
    if (head.__sa) return;
    head.__sa = true;
    initTabs(head);
  });
}
init();
document.addEventListener('shopify:section:load', (e) => init(e.target));
